import React from "react"
import styled from "styled-components"
import Text from "@/common/components/Text"
import Heading from "@/common/components/_UI/Heading"
import Buttons from "@/common/components/_UI/Buttons"
import { flex, theme } from "@/common/Mixin"

interface IntroProps {
  demo?: boolean
  type?: string
  themeNew?: {
    primary?: string
    secondary?: string
  }
  padding?: boolean
  big?: boolean
  white?: boolean
  center?: boolean
  title1?: string
  title2?: string
  title3?: string
  btns?: {
    content: string
    link?: string
  }[]
  desc?: string
  content?: React.ReactNode
}

export default function intro({
  demo, //展示用的 會有預設文案
  type, //用途跟className一樣傳遞值近來
  themeNew, //這邊可以指定primary & secondary 顏色 要用 {primary,secondary} 兩個值傳進來
  padding, //是否有padding
  big, //title2、3字體大小
  white, //title2、3字體顏色 如果沒有的話就是primary
  center, //是否置中
  title1,
  title2,
  title3,
  btns,
  desc,
  content
}: IntroProps) {
  const btnDemo = [{ content: "Start Now" }, { content: "Learn More" }]
  const Class = {
    Wrapper: `${type ? type : ""} ${center ? "center" : ""} ${
      padding ? "padding" : ""
    }`,
    TitleWrapper: `${type ? type : ""} ${center ? "center" : ""}`,
    Heading: `${white ? "" : "primary shadow"} ${type ? type : null} ${
      big ? "big" : ""
    }`,
    Buttons: `${type ? type : ""} ${center ? "center" : ""}`
  }

  return (
    <Wrapper className={Class.Wrapper}>
      <TitlesWrapper className={Class.TitleWrapper}>
        {title1 || demo ? (
          // <Fade>
          <Heading as="h3" content={title1 || "KryproGO Wallet As Service"} />
        ) : // </Fade>
        null}

        {title2 || demo ? (
          // <Fade>
          <Heading
            className={Class.Heading}
            content={title2 || "KryproGO Best Web3 Tool"}
            content2={title3}
            themeNew={themeNew}
          />
        ) : //  </Fade>
        null}
        {desc || demo ? (
          // <Fade bottom>
          <Text content={desc || "Apps into Web3 DApps."} />
        ) : // </Fade>
        null}
        {content && <ContentWrapper>{content}</ContentWrapper>}
        {btns || demo ? (
          <Buttons type={Class.Buttons} btns={btns || btnDemo} />
        ) : null}
      </TitlesWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  width: 100%;
  &.padding {
    padding: 0 var(--padding);
  }

  &.center {
    ${flex({ d: "column", a: "center" })}
    p {
      max-width: 600px;
      margin: 0 auto 8px;
    }
  }
`
const TitlesWrapper = styled.div`
  width: 100%;
  ${flex({ d: "column" })}
  align-items: start;
  gap: var(--textGap);
  &.center {
    margin: 0 auto;
    align-items: center;
    h2,
    h3,
    p {
      text-align: center;
      justify-content: center;
    }
    p {
      max-width: 700px;
    }
  }
  @media (${theme.lg}) {
    ${flex({ d: "column" })}
    h2,h3,p {
      text-align: center;
      justify-content: center;
    }
  }
`

const ContentWrapper = styled.div``
